export default __webpack_public_path__ + "static/media/caera-2.5df73e8d.mp4";